import {
  BooleanStatusIndicator,
  BooleanStatusIndicatorProps,
} from "@/common/components/Status/BooleanStatusIndicator";
import { AvailabilityStatus } from "@/core/api/generated/v1";

interface Props {
  status: AvailabilityStatus | undefined;
  indicatorProps?: Partial<BooleanStatusIndicatorProps>;
}

export function AvailabilityStatusIndicator({ status, indicatorProps }: Props) {
  return (
    <BooleanStatusIndicator
      value={status === AvailabilityStatus.Available}
      size='small'
      {...indicatorProps}
    />
  );
}
